import { useSettingsPageState } from './settings/useSettingsPageState';
import { SettingsPageView } from './settings/SettingsPageView';

export default function SettingsPage({ initialTab = null }) {
    const ctx = useSettingsPageState(initialTab);
    return <SettingsPageView {...ctx} initialTab={initialTab} />;
}
